import * as React from "react";
import { Picture } from "@grandvisionhq/content";
import { generateConditionalClassNames } from "../../../../utils/containers/RowComponent/utils/utils.js";
/* empty css              */
import { parseBloomreachImage } from "../../../../../../utils/utils/parse-bloomreach-image.js";
const CmsRowImage = ({ component }) => {
  const { horizontalAlignment, verticalAlignment, ...cssStyles } = component.getParameters();
  const filteredStyles = Object.fromEntries(
    Object.entries(cssStyles).filter(([_, value]) => value !== "")
  );
  const { image } = component.getModels();
  const parsedImage = parseBloomreachImage(image);
  if (!image) return null;
  const rowImageClassName = generateConditionalClassNames("br-row-image", {
    horizontalAlignment,
    verticalAlignment
  });
  return /* @__PURE__ */ React.createElement("div", { className: rowImageClassName, "data-t": "br-row-image", style: filteredStyles }, /* @__PURE__ */ React.createElement(
    Picture,
    {
      mobileUrl: parsedImage?.mobile.url,
      url: image.url,
      alt: parsedImage?.alt,
      height: image.original.height,
      width: image.original.width
    }
  ));
};
export {
  CmsRowImage,
  CmsRowImage as default
};
//# sourceMappingURL=RowImage.js.map
